import React,{useState} from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode"; // ✅ named import
import { useNavigate, useLocation } from "react-router-dom";
import { BASE_URL } from '../Config/Config';
import { UseGlobellogin } from "./Logincontaxt.jsx/Logincontex";
import { Usecartcontaxt } from './cartcontaxt/cart_contaxt';

function GoogleSignin({ mode }) {
  const navigate = useNavigate();
  const location = useLocation();
  const {AddTocart} = Usecartcontaxt()
  const { storeToken, setsuccessfully } = UseGlobellogin();
  const [errorMessage, setErrorMessage] = useState(""); // <-- UI error
  const from = location.state?.from || "/";
  const autoEnroll = location.state?.autoEnroll || false; // check if auto-enroll is needed

  const showError = (message) => {
    console.error(message);
  };

  const handleSuccess = async (credentialResponse) => {
    try {
      if (!credentialResponse?.credential) {
        showError("No credentials received from Google.");
        setErrorMessage("No credentials received from Google."); 
        return;
      }

      const decoded = jwtDecode(credentialResponse.credential);

      const loginData = {
        user_input: decoded.email,
        is_sso: true,
      };

      const apiUrl =
        mode === "login"
          ? `${BASE_URL}/login/`
          : `${BASE_URL}/usersignup/`;

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(loginData),
      });

      const result = await response.json();

      if (response.ok) {
        setsuccessfully(result.message);
        setTimeout(() => setsuccessfully(""), 7000);
        setErrorMessage("");
        localStorage.setItem("serverToken", result.access_token);
        localStorage.setItem("userEmail", decoded.email);
        localStorage.setItem("user_id", result.user_id);
        localStorage.setItem("user_Name", decoded.name);
        localStorage.setItem("user_img", decoded.picture);
        localStorage.setItem("login_method", 'email');

        window.dispatchEvent(new Event("storage"));
        storeToken();

        // ✅ Auto-enroll if user came from course-detail
        if (autoEnroll && from.includes("/course-detail/")) {
          const courseId = from.split("/course-detail/")[1];
          // Assuming AddTocart is globally accessible or imported
          AddTocart(courseId);
          navigate("/cartpage");
        } else {
          navigate(from); // otherwise go to the page user was trying to access

        }
      } else {
          setErrorMessage(result.message); // show error in UI
          setsuccessfully(result.message);
          setTimeout(() => setsuccessfully(""), 7000);
      }
    } catch (error) {
      console.error("Login Error:", error);
      showError("Something went wrong. Try again.");
    }
  };

  const handleError = () => {
    showError("Google sign-in failed. Try again.");
  };

  return (
     <div className="d-flex flex-column align-items-center justify-content-center">
      {errorMessage && (
        <div className="text-primary   fw-bold mb-2">{errorMessage}</div> // error above UI
      )}
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={handleError}
      />
    </div>
  );
}

export default GoogleSignin;
